import script from "./customerStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./customerStatus.vue?vue&type=script&setup=true&lang=js"

import "./customerStatus.vue?vue&type=style&index=0&id=3d0fb622&lang=scss"

const __exports__ = script;

export default __exports__